export enum CouponCodeViewEnum {
  NONE = "NONE",
  COUPON_APPLIED = "COUPON_APPLIED",
  COUPON_APPLICABLE = "COUPON_APPLICABLE",
  COUPON_CODE_INPUT = "COUPON_CODE_INPUT"
}

export enum Action {
  SET_COUPON_CODE_VIEW = "SET_COUPON_CODE_VIEW"
}
